import { useMemo } from "react";
import { generateAvatar } from "./generateAvatar";

/**
 * The avatar generated from a seed (F14), filling its round frame. The ground colour rings
 * the edge over the pattern, so a light wave never blurs the disc into a light page.
 */
export default function GeneratedAvatar({ seed }: { seed: string }) {
  const { palette, turn, shapes } = useMemo(() => generateAvatar(seed), [seed]);
  return (
    <svg viewBox="0 0 32 32" aria-hidden="true" className="app-avatar-generated">
      <rect width="32" height="32" fill={palette.ground} />
      <g transform={`rotate(${turn} 16 16)`}>
        {shapes.map((shape, index) =>
          shape.kind === "area" ? (
            <path key={index} d={shape.d} fill={palette[shape.tone]} />
          ) : (
            <path key={index} d={shape.d} fill="none" stroke={palette[shape.tone]} strokeWidth={shape.width} strokeLinecap="round" strokeLinejoin="round" />
          ),
        )}
      </g>
      <circle cx="16" cy="16" r="15.25" fill="none" stroke={palette.ground} strokeWidth="1.5" />
    </svg>
  );
}
